/* NANIMERICA card pendant landing · booster pack opening (three.js, loaded on demand).
   Section markup: [data-nrcp-pack] with data-glb, data-logo, data-three and a JSON <script data-cards>.
   Pack model: "Booster Pack (TCG Pack)" by Hasan Ajami, licensed by NANIMERICA. */
(function () {
  if (window.nrCpPack) return;
  window.nrCpPack = true;
  var KEY = 'nrcp-pack-opened';

  /* three.js comes in through an injected module script (theme JS is bundled, so no import() here) */
  var threeP = null;
  function loadThree(urls) {
    if (window.__nrcpThree) return Promise.resolve(window.__nrcpThree);
    if (threeP) return threeP;
    threeP = new Promise(function (res, rej) {
      var t = setTimeout(function () { rej(new Error('three timeout')); }, 15000);
      addEventListener('nrcp-three', function () { clearTimeout(t); window.__nrcpThree ? res(window.__nrcpThree) : rej(new Error('three failed')); }, { once: true });
      var sc = document.createElement('script'); sc.type = 'module';
      sc.textContent = 'try{const T=await import(' + JSON.stringify(urls[0]) + ');const G=await import(' + JSON.stringify(urls[1]) + ');const R=await import(' + JSON.stringify(urls[2]) + ');window.__nrcpThree={T:T,GLTFLoader:G.GLTFLoader,RoomEnvironment:R.RoomEnvironment};}catch(e){}dispatchEvent(new Event("nrcp-three"));';
      document.head.appendChild(sc);
    });
    return threeP;
  }

  function boot(root) {
    if (root.nrPack) return; root.nrPack = true;
    var stage = root.querySelector('[data-stage]');
    var cards = JSON.parse(root.querySelector('script[data-cards]').textContent);
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var opened = false;
    try { opened = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    var base = root.getAttribute('data-three') || 'https://cdn.jsdelivr.net/npm/three@0.160.0';
    var urls = (root.getAttribute('data-three-urls') || [base + '/+esm', base + '/examples/jsm/loaders/GLTFLoader.js/+esm', base + '/examples/jsm/environments/RoomEnvironment.js/+esm'].join('|')).split('|');
    loadThree(urls).then(function (m) { run(m.T, m.GLTFLoader, m.RoomEnvironment); })
      .catch(function () { root.classList.add('is-fallback'); });

    function run(THREE, GLTFLoader, RoomEnvironment) {
      var W = stage.clientWidth, H = stage.clientHeight;
      var renderer;
      try { renderer = new THREE.WebGLRenderer({ antialias: true }); } catch (e) { root.classList.add('is-fallback'); return; }
      /* opaque canvas painted in the section colour: additive light blends inside WebGL, so no compositor halos */
      var bg = getComputedStyle(root).backgroundColor; if (!bg || /^rgba\(.*,\s*0\)$/.test(bg)) bg = '#0e0e0f';
      renderer.setClearColor(new THREE.Color(bg), 1);
      renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
      renderer.setSize(W, H);
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.05;
      renderer.localClippingEnabled = true;
      stage.appendChild(renderer.domElement);
      var scene = new THREE.Scene();
      var pm = new THREE.PMREMGenerator(renderer);
      scene.environment = pm.fromScene(new RoomEnvironment(), 0.04).texture;
      var cam = new THREE.PerspectiveCamera(32, W / H, 0.1, 100);
      function fit() {
        W = stage.clientWidth; H = stage.clientHeight;
        renderer.setSize(W, H); cam.aspect = W / H;
        cam.position.set(0, 0, W / H < 0.8 ? 18 : 16.5);
        cam.updateProjectionMatrix();
      }
      fit(); addEventListener('resize', fit);
      var key = new THREE.DirectionalLight(0xfff1d6, 0.7); key.position.set(3, 5, 8); scene.add(key);
      var rim = new THREE.PointLight(0xc9a64a, 22, 30); rim.position.set(-5, 3, -2); scene.add(rim);
      /* downlight: a warm spot from above, a soft visible beam and a pool of light underneath */
      var spot = new THREE.SpotLight(0xffe2a8, 520, 40, 0.36, 0.6, 1.4); spot.position.set(0, 13, 3.5); scene.add(spot); scene.add(spot.target);
      function beamTex() {
        /* drawn per pixel into a DataTexture (row 0 = bottom): soft edges everywhere, no canvas blur or premultiplied-alpha banding */
        var p = new Uint8Array(128 * 256 * 4);
        for (var yy = 0; yy < 256; yy++) {
          var v = yy / 255, hw = 10 + v * 50, va = 0.8 * Math.min(1, v * 6) * Math.pow(1 - v, 1.15);
          for (var xx = 0; xx < 128; xx++) {
            var h = Math.abs(xx - 63.5) / hw, ha = h >= 1 ? 0 : 1 - h * h * (3 - 2 * h), o = ((255 - yy) * 128 + xx) * 4;
            p[o] = 255; p[o + 1] = 220; p[o + 2] = 160; p[o + 3] = Math.round(255 * va * ha);
          }
        }
        return dataTex(p, 128, 256);
      }
      function dataTex(p, w, h) { var t = new THREE.DataTexture(p, w, h, THREE.RGBAFormat); t.magFilter = t.minFilter = THREE.LinearFilter; t.needsUpdate = true; return t; }
      function poolTex() {
        var p = new Uint8Array(128 * 64 * 4);
        for (var yy = 0; yy < 64; yy++) for (var xx = 0; xx < 128; xx++) {
          var r = Math.min(1, Math.hypot((xx - 63.5) / 64, (yy - 31.5) / 32)), o = (yy * 128 + xx) * 4;
          p[o] = 255; p[o + 1] = 214; p[o + 2] = 140; p[o + 3] = Math.round(255 * 0.45 * Math.pow(1 - r, 2));
        }
        return dataTex(p, 128, 64);
      }
      var beam = new THREE.Mesh(new THREE.PlaneGeometry(10, 14), new THREE.MeshBasicMaterial({ map: beamTex(), transparent: true, depthWrite: false, blending: THREE.AdditiveBlending, opacity: 0.85 }));
      beam.position.set(0, 2.6, -2.4); scene.add(beam);
      var pool = new THREE.Mesh(new THREE.PlaneGeometry(9, 2.4), new THREE.MeshBasicMaterial({ map: poolTex(), transparent: true, depthWrite: false, blending: THREE.AdditiveBlending }));
      pool.position.set(0, -4.1, -0.6); scene.add(pool);

      /* ---------- textures ---------- */
      function canvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
      function goldGrad(x, a, b, c, d) { var g = x.createLinearGradient(a, b, c, d); g.addColorStop(0, '#7a5a17'); g.addColorStop(.22, '#f6dd92'); g.addColorStop(.45, '#a8812c'); g.addColorStop(.68, '#fbe8a8'); g.addColorStop(1, '#86651c'); return g; }
      function spiral(x, cx, cy, rMax, color, lw) {
        x.save(); x.strokeStyle = color; x.lineWidth = lw; x.beginPath();
        for (var t = 0; t < 26; t += 0.05) { var r = rMax * t / 26, px = cx + Math.cos(t) * r, py = cy + Math.sin(t) * r; t ? x.lineTo(px, py) : x.moveTo(px, py); }
        x.stroke(); x.restore();
      }
      var LOGO = null;
      function cardBack() {
        var c = canvas(630, 880), x = c.getContext('2d');
        x.fillStyle = goldGrad(x, 0, 0, 630, 880); x.fillRect(0, 0, 630, 880);
        x.fillStyle = '#0d0c0b'; x.fillRect(24, 24, 582, 832);
        var g = x.createRadialGradient(315, 440, 10, 315, 440, 420); g.addColorStop(0, '#3a2c12'); g.addColorStop(1, '#0d0c0b'); x.fillStyle = g; x.fillRect(24, 24, 582, 832);
        spiral(x, 315, 440, 300, 'rgba(201,166,74,.55)', 5);
        if (LOGO) { x.beginPath(); x.arc(315, 440, 96, 0, 7); x.fillStyle = '#0d0c0b'; x.fill(); x.lineWidth = 5; x.strokeStyle = '#c9a64a'; x.stroke(); x.drawImage(LOGO, 315 - 84, 440 - 84, 168, 168); }
        else { x.beginPath(); x.arc(315, 440, 74, 0, 7); x.fillStyle = '#0d0c0b'; x.fill(); x.lineWidth = 6; x.strokeStyle = '#c9a64a'; x.stroke();
        x.fillStyle = '#e9c97a'; x.font = '700 64px Helvetica,Arial,sans-serif'; x.textAlign = 'center'; x.textBaseline = 'middle'; x.fillText('NA', 315, 444); }
        var t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = 4; return t;
      }
      function cardFront(img, rare) {
        var c = canvas(630, 880), x = c.getContext('2d');
        x.fillStyle = rare ? (function () { var g = x.createLinearGradient(0, 0, 630, 880); g.addColorStop(0, '#6d737c'); g.addColorStop(.22, '#f2f5f9'); g.addColorStop(.45, '#9aa1ab'); g.addColorStop(.68, '#fff'); g.addColorStop(1, '#7b828c'); return g; })() : goldGrad(x, 0, 0, 630, 880);
        x.fillRect(0, 0, 630, 880);
        if (img) { var s = Math.max(582 / img.width, 832 / img.height), w = img.width * s, h = img.height * s; x.save(); x.beginPath(); x.rect(24, 24, 582, 832); x.clip(); x.drawImage(img, 315 - w / 2, 440 - h / 2, w, h); x.restore(); }
        var t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = 4; return t;
      }
      function label(logo) {
        var c = canvas(680, 1000), x = c.getContext('2d');
        x.fillStyle = '#0b0a09'; x.fillRect(0, 0, 680, 1000);
        var g = x.createRadialGradient(340, 430, 20, 340, 430, 520); g.addColorStop(0, '#4a3714'); g.addColorStop(.6, '#15110b'); g.addColorStop(1, '#0b0a09'); x.fillStyle = g; x.fillRect(0, 0, 680, 1000);
        spiral(x, 340, 430, 330, 'rgba(201,166,74,.28)', 4);
        x.strokeStyle = goldGrad(x, 0, 0, 680, 1000); x.lineWidth = 10; x.strokeRect(26, 26, 628, 948);
        x.textAlign = 'center'; x.textBaseline = 'middle';
        if (logo) {
          var lw = 190, lh = logo.height * lw / logo.width;
          x.save(); x.shadowColor = 'rgba(201,166,74,.55)'; x.shadowBlur = 30; x.drawImage(logo, 340 - lw / 2, 160 - lh / 2, lw, lh); x.restore();
          x.fillStyle = '#e9c97a'; x.font = '700 40px Helvetica,Arial,sans-serif'; x.fillText('N A N I M E R I C A', 340, 300);
        } else { x.fillStyle = '#e9c97a'; x.font = '700 50px Helvetica,Arial,sans-serif'; x.fillText('NANIMERICA', 340, 150); }
        x.fillStyle = goldGrad(x, 120, 0, 560, 0);
        x.font = '800 104px Helvetica,Arial,sans-serif'; x.fillText('CARD', 340, 650); x.fillText('PENDANT', 340, 760);
        x.fillStyle = '#c9a64a'; x.font = '700 30px Helvetica,Arial,sans-serif';
        x.fillText('C O L L E C T I O N', 340, 850);
        x.fillStyle = 'rgba(244,242,238,.7)'; x.font = '600 24px Helvetica,Arial,sans-serif'; x.fillText(LABEL_LINE, 340, 920);
        var t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = 8; return t;
      }
      var nRare = cards.filter(function (c) { return c.rare; }).length;
      var LABEL_LINE = cards.length + ' CARDS · ' + nRare + ' RARE PULL' + (nRare === 1 ? '' : 'S');
      function loadImg(src) { return new Promise(function (res) { if (!src) return res(null); var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = function () { res(null); }; i.src = src; }); }

      Promise.all([new Promise(function (res, rej) { new GLTFLoader().load(root.getAttribute('data-glb'), res, null, rej); }), loadImg(root.getAttribute('data-logo'))].concat(cards.map(function (c) { return loadImg(c.img); })))
        .then(function (a) { build(a[0], a[1], a.slice(2)); })
        .catch(function () { root.classList.add('is-fallback'); });

      function build(gltf, logo, imgs) {
        LOGO = logo;
        /* pack: two clipped copies so the top strip can tear away */
        var model = gltf.scene;
        var box = new THREE.Box3().setFromObject(model), ctr = box.getCenter(new THREE.Vector3());
        model.position.sub(ctr);
        var top = box.max.y - ctr.y, TEAR = top - 0.62;
        var labelTex = label(logo);
        var bodyMat = new THREE.MeshPhysicalMaterial({ color: 0x2a2116, metalness: 0.92, roughness: 0.26, clearcoat: 1, clearcoatRoughness: 0.2, envMapIntensity: 0.45, side: THREE.DoubleSide });
        var labelMat = new THREE.MeshPhysicalMaterial({ map: labelTex, metalness: 0.35, roughness: 0.35, clearcoat: 1, clearcoatRoughness: 0.15, envMapIntensity: 0.5, side: THREE.FrontSide });
        var labelMesh = null;
        model.traverse(function (o) { if (!o.isMesh) return; if (o.material.name === 'Material.003') { o.material = labelMat; labelMesh = o; } else o.material = bodyMat; });
        if (labelMesh) { /* same art on the back: mirror the label through the pack (world space) */
          model.updateMatrixWorld(true);
          var back = labelMesh.clone(); back.matrixAutoUpdate = false;
          var wM = new THREE.Matrix4().makeTranslation(0, 0, -0.07).multiply(new THREE.Matrix4().makeRotationY(Math.PI)).multiply(labelMesh.matrixWorld);
          back.matrix.copy(new THREE.Matrix4().copy(model.matrixWorld).invert().multiply(wM));
          model.add(back);
        }
        var lowPlane = new THREE.Plane(new THREE.Vector3(0, -1, 0), TEAR), lowBase = lowPlane.clone();
        var topPlane = new THREE.Plane(new THREE.Vector3(0, 1, 0), -TEAR), topBase = topPlane.clone();
        function clipped(src, plane) {
          var m = src.clone(true);
          m.traverse(function (o) { if (o.isMesh) { o.material = o.material.clone(); o.material.clippingPlanes = [plane]; o.material.clipShadows = true; } });
          return m;
        }
        var pack = new THREE.Group(); scene.add(pack);
        var lower = new THREE.Group(); lower.add(clipped(model, lowPlane)); pack.add(lower);
        var upper = new THREE.Group(); upper.add(clipped(model, topPlane)); pack.add(upper);
        pack.scale.setScalar(0.92);

        /* cards */
        var CW = 3.15, CH = 4.4, backTex = cardBack();
        var deck = new THREE.Group(); scene.add(deck);
        var cardObjs = cards.map(function (c, i) {
          var g = new THREE.Group();
          var front = new THREE.Mesh(new THREE.PlaneGeometry(CW, CH), new THREE.MeshBasicMaterial({ map: cardFront(imgs[i], c.rare), toneMapped: false }));
          var rear = new THREE.Mesh(new THREE.PlaneGeometry(CW, CH), new THREE.MeshPhysicalMaterial({ map: backTex, metalness: 0.4, roughness: 0.35, clearcoat: 1 }));
          rear.rotation.y = Math.PI; front.position.z = 0.004; rear.position.z = -0.004;
          g.add(front, rear); g.userData = c; g.rotation.y = Math.PI; g.position.set(0, -0.4, -0.01 - i * 0.012); g.visible = false;
          deck.add(g); return g;
        });
        var haloTex = (function () { var c = canvas(256, 256), x = c.getContext('2d'), g = x.createRadialGradient(128, 128, 0, 128, 128, 128); g.addColorStop(0, 'rgba(220,232,255,.9)'); g.addColorStop(.4, 'rgba(170,190,230,.35)'); g.addColorStop(1, 'rgba(170,190,230,0)'); x.fillStyle = g; x.fillRect(0, 0, 256, 256); return new THREE.CanvasTexture(c); })();
        var halos = cardObjs.filter(function (g) { return g.userData.rare; }).map(function (g) {
          var h = new THREE.Sprite(new THREE.SpriteMaterial({ map: haloTex, transparent: true, depthWrite: false, blending: THREE.AdditiveBlending, opacity: 0 }));
          h.scale.set(7.5, 7.5, 1); h.userData.card = g; scene.add(h); return h;
        });

        /* sparks along the tear */
        var N = 90, sp = new Float32Array(N * 3), sv = [];
        for (var i = 0; i < N; i++) sv.push(new THREE.Vector3());
        var sparkGeo = new THREE.BufferGeometry(); sparkGeo.setAttribute('position', new THREE.BufferAttribute(sp, 3));
        var sparks = new THREE.Points(sparkGeo, new THREE.PointsMaterial({ color: 0xffd98a, size: 0.09, transparent: true, opacity: 0, blending: THREE.AdditiveBlending, depthWrite: false }));
        scene.add(sparks);

        /* interaction */
        var px = 0, py = 0, state = opened ? 'done' : 'idle', t0 = 0, hint = root.querySelector('[data-hint]');
        stage.addEventListener('pointermove', function (e) { var r = stage.getBoundingClientRect(); px = (e.clientX - r.left) / r.width - .5; py = (e.clientY - r.top) / r.height - .5; });
        stage.addEventListener('pointerleave', function () { px = py = 0; });
        var sy = null;
        stage.addEventListener('pointerdown', function (e) { sy = e.clientY; });
        stage.addEventListener('pointerup', function (e) {
          if (state === 'idle') { open(); return; }
          if (state === 'done') pick(e);
        });
        root.querySelectorAll('[data-open]').forEach(function (b) { b.addEventListener('click', function () { if (state === 'idle') open(); }); });
        stage.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && state === 'idle') { e.preventDefault(); open(); } });
        root.querySelectorAll('[data-again]').forEach(function (b) { b.addEventListener('click', reset); });
        function open() { state = 'shake'; t0 = performance.now(); root.classList.add('is-opening'); try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
        function reset() { state = 'idle'; root.classList.remove('is-opening', 'is-open'); lay(0); }
        var ray = new THREE.Raycaster(), v2 = new THREE.Vector2();
        function pick(e) {
          var r = stage.getBoundingClientRect(); v2.set(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
          ray.setFromCamera(v2, cam);
          var hit = ray.intersectObjects(cardObjs, true)[0];
          if (!hit) return;
          var o = hit.object; while (o.parent && !o.userData.target) o = o.parent;
          var el = document.querySelector(o.userData.target);
          if (el) { el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); el.classList.add('nrcp-hl'); setTimeout(function () { el.classList.remove('nrcp-hl'); }, 1800); }
        }
        stage.addEventListener('pointermove', function (e) {
          if (state !== 'done') { stage.style.cursor = state === 'idle' ? 'pointer' : ''; return; }
          var r = stage.getBoundingClientRect(); v2.set(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
          ray.setFromCamera(v2, cam); stage.style.cursor = ray.intersectObjects(cardObjs, true).length ? 'pointer' : '';
        });

        /* layout of the opened spread */
        var n = cardObjs.length, mob = function () { return W / H < 0.8; };
        var gi = 0, ri = 0;
        cardObjs.forEach(function (g) { if (g.userData.rare) g.userData.ri = ri++; else g.userData.gi = gi++; });
        var nG = gi, nR = ri;
        function slot(i) {
          var u = cardObjs[i].userData;
          if (mob()) { /* gold 2x2 on top, rare pulls side by side underneath */
            if (u.rare) return { x: nR > 1 ? (u.ri ? 1.15 : -1.15) : 0, y: -2.75, z: 0.6, rz: nR > 1 ? (u.ri ? -0.04 : 0.04) : 0, s: nR > 1 ? 0.64 : 0.76 };
            return { x: (u.gi % 2 ? 1 : -1) * 1.1, y: u.gi < 2 ? 3.45 : 0.5, z: 0, rz: (u.gi % 2 ? 1 : -1) * 0.04, s: 0.62 };
          }
          if (u.rare) return { x: nR > 1 ? (u.ri ? 1.55 : -1.55) : 0, y: -0.2, z: 1.4, rz: nR > 1 ? (u.ri ? -0.04 : 0.04) : 0, s: 0.9 };
          var half = nG / 2, k = u.gi < half ? u.gi - half : u.gi - half + 1; /* -2,-1 | 1,2 */
          var xs = nR > 1 ? [0, 4.05, 6.45] : [0, 2.75, 5.5];
          return { x: (k < 0 ? -1 : 1) * xs[Math.abs(k)], y: -0.45 - Math.abs(k) * 0.2, z: -Math.abs(k) * 0.3, rz: -k * 0.07, s: nR > 1 ? 0.74 : 0.8 };
        }
        function lay() { cardObjs.forEach(function (g) { g.visible = false; }); }
        function ease(t) { return t < 0 ? 0 : t > 1 ? 1 : 1 - Math.pow(1 - t, 3); }
        function easeIO(t) { return t < 0 ? 0 : t > 1 ? 1 : t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

        if (opened) { root.classList.add('is-open'); }
        var clock = performance.now();
        renderer.setAnimationLoop(function (now) {
          var t = (now - clock) / 1000, e = now - t0;
          var tx = py * 0.35, ty = px * 0.6;
          if (state === 'idle') {
            pack.visible = true; pack.position.set(0, Math.sin(t * 1.4) * 0.12, 0);
            pack.rotation.x += ((reduce ? 0 : tx) - pack.rotation.x) * 0.08;
            pack.rotation.y += ((reduce ? 0 : ty + Math.sin(t * 0.7) * 0.18) - pack.rotation.y) * 0.08;
            upper.visible = true; upper.position.set(0, 0, 0); upper.rotation.set(0, 0, 0); lower.position.set(0, 0, 0);
            cardObjs.forEach(function (g, i) { g.visible = false; g.position.set(0, -0.4, -0.01 - i * 0.012); g.rotation.set(0, Math.PI, 0); g.scale.setScalar(1); });
            halos.forEach(function (h) { h.material.opacity = 0; }); sparks.material.opacity = 0; sparks.visible = true;
          } else if (state === 'shake') {
            var k = Math.min(1, e / 420); pack.rotation.z = Math.sin(e / 18) * 0.05 * (1 - k); pack.rotation.y *= 0.9; pack.rotation.x *= 0.9;
            if (e > 420) { state = 'tear'; t0 = now; pack.rotation.set(0, 0, 0);
              for (var s = 0; s < N; s++) { var xx = (Math.random() - .5) * 3.8; sp[s * 3] = xx * 0.92; sp[s * 3 + 1] = TEAR * 0.92 + pack.position.y; sp[s * 3 + 2] = 0.2; sv[s].set((Math.random() - .5) * 0.08 + xx * 0.01, Math.random() * 0.09 + 0.02, (Math.random() - .2) * 0.06); }
              sparkGeo.attributes.position.needsUpdate = true; }
          } else if (state === 'tear') {
            var k1 = ease(e / 700);
            upper.position.set(k1 * 3.2, k1 * 2.6, k1 * 1.5); upper.rotation.set(-k1 * 0.9, 0, -k1 * 1.1);
            sparks.material.opacity = Math.max(0, 1 - e / 900);
            for (var q = 0; q < N; q++) { sp[q * 3] += sv[q].x; sp[q * 3 + 1] += sv[q].y; sp[q * 3 + 2] += sv[q].z; sv[q].y -= 0.004; }
            sparkGeo.attributes.position.needsUpdate = true;
            if (e > 700) { state = 'rise'; t0 = now; upper.visible = false; cardObjs.forEach(function (g) { g.visible = true; }); }
          } else if (state === 'rise') {
            /* stack rises out of the pack, pack slides down and fades */
            var k2 = easeIO(e / 1100);
            cardObjs.forEach(function (g, i) { g.position.y = -0.4 + k2 * 4.6 + i * 0.02; });
            lower.position.y = -k2 * 9; sparks.material.opacity = Math.max(0, sparks.material.opacity - 0.03);
            if (e > 1100) { state = 'spread'; t0 = now; pack.visible = false; sparks.visible = false; }
          } else if (state === 'spread' || state === 'done') {
            var done = state === 'done';
            cardObjs.forEach(function (g, i) {
              var rare = g.userData.rare, d = rare ? 900 + g.userData.ri * 260 : g.userData.gi * 160, sl = slot(i);
              var k3 = done ? 1 : easeIO((e - d) / 700), kf = done ? 1 : ease((e - d - 350) / 650);
              g.position.set(sl.x * k3, 4.2 * (1 - k3) + sl.y * k3 + (done && !reduce ? Math.sin(t * 1.3 + i) * 0.06 : 0), (-0.01 - i * 0.012) * (1 - k3) + sl.z * k3);
              g.scale.setScalar(1 + (sl.s - 1) * k3);
              g.rotation.set(done && !reduce ? py * 0.25 : 0, Math.PI * (1 - kf) + (done && !reduce ? px * 0.35 : 0), sl.rz * k3);
            });
            halos.forEach(function (h) { var rg = h.userData.card; h.position.set(rg.position.x, rg.position.y, rg.position.z - 0.2); h.material.opacity = 0; });
            if (!done && e > 2400) { state = 'done'; root.classList.add('is-open'); root.classList.remove('is-opening'); }
          }
          if (state === 'done' && opened && !root.classList.contains('is-open')) root.classList.add('is-open');
          /* the downlight is for the sealed pack only: it fades out once the cards are out so they show true to the photos */
          var lit = state === 'idle' || state === 'shake' || state === 'tear' ? 1 : 0;
          spot.intensity += (520 * lit - spot.intensity) * 0.05; beam.material.opacity += (0.85 * lit - beam.material.opacity) * 0.05; pool.material.opacity += (lit - pool.material.opacity) * 0.05;
          pool.scale.x = W / H < 0.8 ? 0.62 : 1;
          renderer.render(scene, cam);
        });
        if (opened) { state = 'done'; t0 = 0; pack.visible = false; sparks.visible = false; cardObjs.forEach(function (g) { g.visible = true; }); }
        root.classList.add('is-ready');
      }
    }
  }

  function scan() {
    document.querySelectorAll('[data-nrcp-pack]').forEach(function (root) {
      if (root.nrSeen) return; root.nrSeen = true;
      if (!('IntersectionObserver' in window)) return boot(root);
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); boot(root); } }, { rootMargin: '400px 0px' });
      io.observe(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
